import { createAction, props } from '@ngrx/store';

import { PmsCredentialModel } from '@shared/interfaces/pms-credential-model.interface';
import { RestChatHooksChannel } from '@shared/interfaces/rest-chat-hooks-channel';
import { RestTimerReport } from '@shared/interfaces/rest-timer-report';

/**
 * get System Config
 */
export const getSystemConfig = createAction('[System Config] get System Config');
export const getSystemConfigSuccess = createAction(
  '[System Config] get System Config success',
  props<{ systemConfig: PmsCredentialModel[] }>()
);
export const getSystemConfigError = createAction('[System Config] get System Config error');

/**
 * update System Config
 */
export const updateSystemConfig = createAction(
  '[System Config] update System Config',
  props<{ pmsCredential: PmsCredentialModel }>()
);
export const deleteSystemConfig = createAction('[System Config] delete System Config', props<{ id: number }>());
export const updateSystemConfigSuccess = createAction('[System Config] update System Config success');
export const updateSystemConfigError = createAction('[System Config] update System Config error');

/**
 * Timer Report
 */

export const getTimerReport = createAction('[System Config] getTimerReport');
export const getTimerReportSuccess = createAction(
  '[System Config] getTimerReportSuccess',
  props<{ timerReport: RestTimerReport[] }>()
);
export const getTimerReportError = createAction('[System Config] getTimerReportError');

/**
 * chat hooks
 */

export const getChatChannels = createAction('[System Config] getChatChannels');
export const getChatChannelsSuccess = createAction(
  '[System Config] getChatChannelsSuccess',
  props<{ channels: RestChatHooksChannel[] }>()
);
export const getChatChannelsError = createAction('[System Config] getChatChannelsError');

export const setPropertyChatChannels = createAction(
  '[System Config] setPropertyChatChannels',
  props<{ channelIds: string[]; propertyId: number }>()
);
export const setPropertyChatChannelsSuccess = createAction('[System Config] setPropertyChatChannelsSuccess');
export const setPropertyChatChannelsError = createAction('[System Config] setPropertyChatChannelsError');

export const setSystemSectionExpanded = createAction(
  '[System Config] setSystemSectionExpanded',
  props<{ section: 'API' | 'Hooks' | 'DateTime' | 'TimerReport'; state: boolean }>()
);
